// extracted by mini-css-extract-plugin
export default {"addButton":"WVbJSnlg0qROkp7eFVmw","wrapperContainer":"Y9llQEkV5wCcXXkDiQcq","borderRight":"jAu21zPxjO1zuG8cJHNZ","addText":"lxe9dogPtcakEHZj0Znd","tooltip":"j_ywxQj9kfPDEX_Mr7qv"};